import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { formatCoverageNote } from '../../utils/nhStyleFingerprintSnapshot';

function NhStyleFingerprintCoverageNote({ identity }) {
  const note = formatCoverageNote(identity);
  return (
    <Typography variant="body2" sx={{ my: 1 }}>
      {note}
      {' '}
      <Link component={RouterLink} to="/beer-styles">
        Beer styles
      </Link>
    </Typography>
  );
}

export default NhStyleFingerprintCoverageNote;
